import React from 'react';

import { STAFF_NEEDS_LIST_QUERY_KEY } from '../../Organization/Needs/queryKeys';
import { NeedsListPage } from '../../shared/needs';

export const StaffNeedsList: React.FC = () => {
  return (
    <NeedsListPage
      title="Needs"
      queryKeyBase={STAFF_NEEDS_LIST_QUERY_KEY}
      displayTypePrefKey="StaffNeeds"
      showOrganization={true}
      showOrganizationFilter={true}
      linkContext="staff"
    />
  );
};
